<template>
  <div style="height: 100%;">
    <iframe id="marketReport" width="100%"
      frameborder="no" border="0" marginwidth="0" marginheight="0" scrolling="no" SameSite="None" allowtransparency="yes"
      :src="reportUrl"></iframe>
  </div>
</template>

<script>
export default {
  name: 'marketReportComponent',
  data () {
    return ({
      reportUrl: 'https://oohbi.ooh.oohforce.com:25025/webroot/decision/v5/design/report/121c96ce984547fda0731a67ba5bfc53/view?ssoToken=IuJLU%2FpC3aYCaLzNRC6UVyMPeQ1BYsgj%2BAyFrDxv6eYKwKSRiNsM5i5tcEtN81z5CWoVPzIBPkmdwkRV9EtRSWugfbQhL9KBLqUGc%2BCAead5mwD1aNMeDEl4MSIqTmlunAvKQBRAIK5O72BtOx4yncihrQg4aRYUpp%2FBOdKmDsP1p7JjfURde2%2B5HIFptEPlgaN2PQtCSjKl1m86hKhLVpuJiZGBUu6NoqTFLMEYwtxYShFIoQA8a2M%2FhLA0h2js0IdKFuENl7zmARlvSs5zuvvnvAaL7sKXJD7Dl%2Fv0BnbW4bOtnz4joxfbXI5dA4tJROA8xIGpmCW1oLlvw7oZOQ%3D%3D'
    })
  },
  mounted () {
    // 设置中间区域地图高度
    this.$nextTick(() => {
      document.getElementById('marketReport').style.height = document.body.clientHeight - 5 + 'px'
    })
  }
}
</script>
